<template>
    <div>
        <v-container>
            <v-layout align-center mb-4 style="position: relative;">
                <strong class="mx-3">
                    Onboarding: {{ completedOnboardingTasks }}/{{ totalOnboardingTasks }}
                </strong>
                <v-divider vertical></v-divider>
                <strong class="mx-3">
                    Management: {{ completedManagementTasks }}/{{ totalManagementTasks }}
                </strong>
            </v-layout>
            <v-row>
                <v-col cols="12">
                    <v-data-table hide-default-footer :sort-by.sync="sortBy" :headers="headers" :items="tasks" :options="options">
                        <template v-slot:item.completed="{ item }">
                            <v-btn v-if="item.completed" @click="taskComplete(item)" block small color="green" class="button-style" outlined dark>Completed</v-btn>
                            <v-btn v-if="!item.completed" @click="taskComplete(item)" block small color="red" class="button-style" dark elevation="0">Incomplete</v-btn>
                        </template>
                        <template v-slot:item.stage="{ item }">
                            <v-btn block small v-if="item.stage == 'Onboarding'" color="#d2d2d2" class="button-style" dark elevation="0">Onboarding</v-btn>
                            <v-btn block small v-else color="#252525" class="button-style" dark elevation="0">Management</v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import moment from 'moment'
    export default {
        name: 'Onboarding',
        data(){
            return {
                id: this.$route.params.id,
                adminUser: this.$store.getters.currentAdminUser, 
                client: {},
                headers: [
                    { text: 'Stage', value: 'stage' },
                    { text: 'Task', value: 'text' },
                    { text: 'Status', value: 'completed' },
                    { text: 'Last edit', value: 'authorShort' },
                    { text: 'Owner', value: 'owner' },
                    { text: 'Completed', value: 'completedDate' }
                ],
                sortBy: ['stage'],
                options:{
                    itemsPerPage: 100
                },
                tasks: [],
                totalOnboardingTasks: 0,
                completedOnboardingTasks: 0,
                totalManagementTasks: 0,
                completedManagementTasks: 0
            }
        },
        computed: {
            progress () {
                return this.completedOnboardingTasks / this.totalOnboardingTasks * 100
            }
        },
        methods: {
            getStuff(){
                firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                    this.client = docSnapshot.data()
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            loadTasks(){
                this.tasks = []
                firebase.firestore().collection('clients').doc(this.id).collection('tasks').onSnapshot(snapshot => {
                    this.tasks = []
                    snapshot.forEach(doc => {
                        let task = doc.data()
                        if(doc.data().completed){
                            let taskCompletedTime = Number(doc.data().completedDate)
                            taskCompletedTime = moment(taskCompletedTime).format('ll')
                            task.completedDate = taskCompletedTime
                        }else{}
                        this.tasks.push(task)
                        this.calculateTasksRatio()
                    })
                })
            },
            calculateTasksRatio(){
                firebase.firestore().collection('clients').doc(this.id).onSnapshot(docSnapshot => {
                    this.totalOnboardingTasks = docSnapshot.data().totalOnboardingTasks
                    this.completedOnboardingTasks = docSnapshot.data().completedOnboardingTasks
                    this.totalManagementTasks = docSnapshot.data().totalManagementTasks
                    this.completedManagementTasks = docSnapshot.data().completedManagementTasks
                }, err => { console.log(`Encountered error: ${err}`) })
            },
            taskComplete(item){
                let docName = item.createdDate.toString()
                var index = item
                let updatedTime = Number(new Date()).toString()
                index.time = Number(new Date()).toString()
                // if completed
                if(index.completed == false){
                    index.completed = true
                    index.owner = this.adminUser.email
                    index.completedDate = updatedTime.toString()
                    index.completedBy = this.adminUser.email
                    if(index.stage == 'Onboarding'){
                        index.type = 'Onboarding Task Completed'
                        this.client.completedOnboardingTasks ++
                    }else{
                        index.type = 'Management Task Completed'
                        this.client.completedManagementTasks ++
                    }
                    this.client.updatedDate = index.time
                    this.client.updatedBy = this.adminUser.email
                    // update client document
                    firebase.firestore().collection('clients').doc(this.id).update(this.client)
                    // update task
                    firebase.firestore().collection('clients').doc(this.id).collection('tasks').doc(docName).set(index).catch(err => { console.log('Error:', err) })
                }else{
                    index.completed = false
                    index.completedDate = null
                    index.completedBy = null
                    index.owner = this.adminUser.email
                    if(index.stage == 'Onboarding'){
                        index.type = 'Onboarding Task Failed'
                        this.client.completedOnboardingTasks --
                    }else{
                        index.type = 'Management Task Failed'
                        this.client.completedManagementTasks --
                    }
                    this.client.updatedDate = index.time
                    this.client.updatedBy = this.adminUser.email
                    // update client document
                    firebase.firestore().collection('clients').doc(this.id).update(this.client)
                    // update task
                    firebase.firestore().collection('clients').doc(this.id).collection('tasks').doc(docName).set(index).catch(err => { console.log('Error:', err) })
                }
                // add to activity collection as with correct type and enriched data
                let activity = index
                activity.authorEmail = this.adminUser.email
                activity.authorShort = this.adminUser.short
                activity.authorLastName = this.adminUser.lastName
                activity.authorFirstName = this.adminUser.firstName
                firebase.firestore().collection('activity').doc(updatedTime.toString()).set(activity)
                this.loadTasks()
            }
        },
        mounted(){
            this.getStuff()
            this.loadTasks()
            document.title = "Vaboo Onboarding - " + this.client.company
        }
    }
</script>
<style>
</style>